import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./CookieConsent.css";

const STORAGE_KEY = "clubsagent_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch (e) {
      // localStorage no disponible (modo privado) → mostramos el aviso igualmente
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* no-op */
    }
    setVisible(false);
  };

  // No mostrar el banner sobre la propia página de cookies
  if (!visible || location.pathname === "/cookies") return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Aviso de cookies">
      <div className="cookie-consent-inner">
        <p className="cookie-consent-text">
          Usamos <strong>cookies técnicas necesarias</strong> para el inicio de sesión y la seguridad
          del sitio. No usamos cookies de analítica ni publicidad. Más información en nuestra{" "}
          <Link to="/cookies">Política de Cookies</Link>.
        </p>
        <div className="cookie-consent-actions">
          <button
            type="button"
            className="cookie-btn cookie-btn-ghost"
            onClick={() => decide("rejected")}
          >
            Rechazar
          </button>
          <button
            type="button"
            className="cookie-btn cookie-btn-primary"
            onClick={() => decide("accepted")}
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
